import React, { useRef } from "react";
import { teammisionData } from "../content/content";
import useGsapAnimations from "../../hooks/useGsapAnimations";

const Teammisions = () => {
  // Define refs for animations
  const heroRef = useRef(null);
  const sectionRefs = useRef([]);
  const newsletterRef = useRef(null);

  // Apply custom GSAP animations
  useGsapAnimations({
    hero: heroRef,
    sections: sectionRefs,
    newsletter: newsletterRef,
  });

  if (!teammisionData || !teammisionData[0].sections) return null;

  return (
    <div>
      {/* Hero Section */}
      <div
        ref={heroRef}
        className="relative bg-cover bg-center min-h-screen flex flex-col items-center justify-center text-white px-4 sm:px-6 text-center"
        style={{
          backgroundImage: `url(${teammisionData[0].Image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black opacity-60"></div>

        {/* Content */}
        <div className="relative mt-[-30px] sm:mt-[-50px] gap-y-9 z-10 w-full max-w-7xl px-4 sm:px-8">
          {teammisionData[0].sections.map((section, index) => (
            <div
              key={index}
              ref={(el) => (sectionRefs.current[index] = el)}
              className="mb-12 sm:mb-16 slide-up"
            >
              <h1 className="text-2xl sm:text-3xl font-extrabold text-left sm:text-justify leading-tight">
                {section.title}
              </h1>
              <p className="mt-3 sm:mt-4 text-gray-300 text-sm sm:text-lg leading-relaxed text-left sm:text-justify">
                {section.text}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Newsletter Section */}
      <div
        ref={newsletterRef}
        className="relative w-full bg-cover bg-center py-8 sm:py-10 px-6 sm:px-10 flex flex-col sm:flex-row items-center sm:justify-between bg-[#8a702b]"
        style={{
          backgroundImage: "url('/path-to-your-background-image.jpg')",
        }}
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>

        {/* Content Container */}
        <div className="relative z-10 w-full max-w-4xl text-center sm:text-left">
          {/* Newsletter Text */}
          <h2 className="text-xl sm:text-3xl font-bold text-white">Newsletter</h2>
          <p className="mt-2 text-gray-300 text-sm sm:text-base">
            Sign up for our newsletter to get updated news and articles about the company.
          </p>

          {/* Signup Form */}
          <div className="mt-5 flex flex-col sm:flex-row justify-center sm:justify-start items-center w-full ">
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full sm:w-80 p-3 text-black rounded-t-md sm:rounded-l-md sm:rounded-t-none focus:outline-none slide-in"
            />
            <button className="w-full sm:w-auto bg-yellow-400 text-black px-5 py-3 font-bold uppercase rounded-b-md sm:rounded-r-md sm:rounded-b-none hover:bg-yellow-500 transition duration-300 ">
              SIGN UP
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Teammisions;
